import { useState } from 'react';
import { ProfilleDataFieldsFragment } from '@src/generated/graphql';
import { highlightUnderscoreText } from 'src/utils/utils';
import DynamicMedia from 'src/components/shared/DynamicMedia';

type EventProfileListProps = {
  content: ProfilleDataFieldsFragment;
};

const EventProfileList = ({ content }: EventProfileListProps) => {
  const { title, description, profileCollection } = content;
  return (
    <div className="leaders-component">
      <div className="container">
        <div className="header">
         
            <h2 className="content-title"
              dangerouslySetInnerHTML={{
                __html: highlightUnderscoreText(title ?? ''),
              }}
            />
          
          <p className="content-description">{description}</p>
        </div>
        <div className="leaders-card-layout">
          {profileCollection?.items.map((profileCollection, index) => {
            if (!profileCollection) return null;
            const image = profileCollection?.image?.url;
            const logo = profileCollection?.logo?.url;
            const position = profileCollection?.position;
            const title = profileCollection?.title;
            const tag = profileCollection?.tagsCollection?.items[0]?.title;
            // const bgImage = tab?.tabBackgroundImage?.url;

            return (
              <div className="leader-card">
                <div className="leader-card-img">
                  <DynamicMedia
                    src={image ?? ''}
                    alt={profileCollection?.image?.title ?? ''}
                    ariaLabel={profileCollection?.image?.title ?? ''}
                    lottieClassName="lottie"
                    videoAutoplay={false}
                    lottieProps={{
                      loop: true,
                      autoplay: false,
                    }}
                  />
                </div>
                <div className="leader-content">
                  <div className="leaders-logo">
                    <DynamicMedia
                      src={logo ?? ''}
                      alt={profileCollection?.logo?.title ?? ''}
                      ariaLabel={profileCollection?.logo?.title ?? ''}
                      lottieClassName="lottie"
                      videoAutoplay={false}
                      lottieProps={{
                        loop: true,
                        autoplay: false,
                      }}
                    />
                  </div>
                  <h3 className="leader-name">{profileCollection?.title}</h3>
                  <p className="leaders-designation">{profileCollection?.position}</p>
                  {profileCollection?.tagsCollection?.items?.length ? (
                    <div className="leaders-tags">
                      {profileCollection.tagsCollection.items.map(
                        (tag, tagIdx) =>
                          tag?.title && (
                            <span className="leaders-tag" key={tagIdx}>
                              {tag.title}
                            </span>
                          ),
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EventProfileList;
